/**
 * Quando o usuário navega pelas fotos do produto (setinhas, swipe ou
 * miniaturas), seleciona automaticamente TODAS as opções (Cor, Polos,
 * Amperagem, etc.) da variante correspondente àquela foto — sem
 * pré-selecionar nada no carregamento da página, só reage à troca de
 * foto feita pelo usuário.
 *
 * Depende do mapa `[{ mediaId, valueIds: [...] }]` impresso pelo snippet
 * `product-media-gallery.liquid` em `[data-media-color-map]`.
 *
 * Detecção por polling (em vez de MutationObserver em classes do Swiper)
 * pra não depender de exatamente quais classes/elementos o Swiper toca
 * durante a transição — muito mais simples de garantir que funciona.
 */
(function () {
  var LOG_PREFIX = '[mtx-color-sync]';
  var POLL_MS = 250;

  function log() {
    if (window.MTX_COLOR_SYNC_SILENT) return;
    console.info.apply(console, [LOG_PREFIX].concat(Array.prototype.slice.call(arguments)));
  }

  function activeMediaId(sliderList) {
    var items = sliderList.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)');
    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains('swiper-slide-active')) {
        return items[i].dataset.mediaId;
      }
    }
    // Fallback: nenhum item marcado como ativo ainda (slider não iniciou) — usa o primeiro.
    return items[0] ? items[0].dataset.mediaId : null;
  }

  function applyValue(sectionId, valueId) {
    // Busca o <variant-selects> pelo ID a cada chamada — nunca guarda a
    // referência, porque o tema troca esse nó inteiro (ID novo) a cada
    // mudança de opção (ver HTMLUpdateUtility.viewTransition em theme.js),
    // deixando qualquer referência antiga presa num elemento removido.
    var variantSelects = document.getElementById('variant-selects-' + sectionId);
    if (!variantSelects) {
      log('seção', sectionId, '— <variant-selects> não encontrado no momento da aplicação.');
      return false;
    }

    var input = variantSelects.querySelector('[data-option-value-id="' + valueId + '"]');
    if (!input) {
      log('valor', valueId, 'não encontrado no seletor de variantes.');
      return false;
    }

    // Obs.: o tema marca `disabled`/`hidden` em valores considerados
    // "indisponíveis" com base nas OUTRAS opções ainda não escolhidas —
    // não reflete a foto que está sendo exibida. Como esse valor veio do
    // mapa foto->variante (gerado a partir de variantes reais), ignoramos
    // esse estado e forçamos a seleção mesmo assim.
    if (input.tagName === 'INPUT') {
      if (input.checked) return false;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      log('opção selecionada (radio):', input.value);
      return true;
    }

    if (input.tagName === 'OPTION') {
      var select = input.closest('select');
      if (!select) return false;
      if (select.value === input.value) return false;
      select.value = input.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      log('opção selecionada (select):', input.value);
      return true;
    }

    return false;
  }

  function applyEntry(sectionId, entry) {
    entry.valueIds.forEach(function (valueId) {
      applyValue(sectionId, valueId);
    });
  }

  function init(mapScript) {
    if (mapScript.dataset.mtxColorSyncInit === 'true') return; // evita duplo-init se o snippet renderizar 2x
    mapScript.dataset.mtxColorSyncInit = 'true';

    var sectionId = mapScript.getAttribute('data-media-color-map');
    var sliderList = document.getElementById('Slider-Gallery-' + sectionId);

    if (!sliderList || !document.getElementById('variant-selects-' + sectionId)) {
      log('seção', sectionId, '— slider ou seletor de variantes não encontrado, abortando.');
      return;
    }

    var map;
    try {
      map = JSON.parse(mapScript.textContent);
    } catch (e) {
      log('seção', sectionId, '— mapa foto->variante inválido.', e);
      return;
    }
    if (!Array.isArray(map) || !map.length) return;

    log('ativo na seção', sectionId, '—', map.length, 'foto(s) mapeada(s) pra variante.');

    var lastMediaId = activeMediaId(sliderList);
    var lastAppliedMediaId = null;

    setInterval(function () {
      var mediaId = activeMediaId(sliderList);
      if (!mediaId || mediaId === lastMediaId) return;
      lastMediaId = mediaId;

      var entry = map.find(function (item) {
        return String(item.mediaId) === String(mediaId);
      });

      if (!entry) {
        log('foto', mediaId, 'sem variante mapeada, ignorando.');
        return;
      }

      lastAppliedMediaId = mediaId;
      applyEntry(sectionId, entry);

      // O tema substitui o <variant-selects> inteiro por um nó novo ao
      // reagir ao `change` (pra atualizar preço/SKU), com um delay de
      // ~500ms antes de remover o nó antigo. Reaplica algumas vezes nesse
      // intervalo, sempre buscando o nó atual pelo ID, pra garantir que a
      // seleção sobrevive à troca de DOM.
      [150, 350, 600, 900].forEach(function (delay) {
        setTimeout(function () {
          if (lastAppliedMediaId === mediaId) {
            applyEntry(sectionId, entry);
          }
        }, delay);
      });
    }, POLL_MS);
  }

  function start() {
    document.querySelectorAll('[data-media-color-map]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
